// extracted by mini-css-extract-plugin
module.exports = {"container":"EbsInformer_container__8Mpuh","content":"EbsInformer_content__UEcap","imageContainer":"EbsInformer_imageContainer__JwOk_"};